import { render } from "./TermsGate.vue?vue&type=template&id=f7295668&scoped=true"
import script from "./TermsGate.vue?vue&type=script&lang=js"
export * from "./TermsGate.vue?vue&type=script&lang=js"

import "./TermsGate.vue?vue&type=style&index=0&id=f7295668&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7295668"]])

export default __exports__